<div class="button-container" (click)="preventEventPropagationIfDisabled($event)">
  <app-pencil-button
    class="menu-item"
    [class.rendered-in-bottom-sheet]="renderedInBottomSheet$ | async"
    [class.menu-opened]="isMenuOpened"
    [icon]="icon"
    [label]="label"
    [subtitle]="subtitle"
    [badge]="badge"
    [iconConfig]="iconConfig"
    [disabled]="disabled"
    [selected]="selected"
    [showSpinner]="showSpinner"
    (clickEvent)="handleClick($event)"
    (mouseEnterEvent)="handleMouseEnter($event)"
    (mouseLeaveEvent)="handleMouseLeave($event)"
  >
    <app-pencil-icon
      placeAtTheEnd
      *ngIf="proBadge"
      class="pro_badge"
      [name]="'pro_badge'"
      [type]="'svg-icon'"
    ></app-pencil-icon>

    <div placeAtTheEnd class="beta-badge" *ngIf="betaBadge" placement="left">beta</div>

    <div placeAtTheEnd class="right-icons" *ngIf="forMenu || renderCheckIcon || endSideContent">
      <ng-content select="[placeBeforeMoreIcon]"></ng-content>

      <app-pencil-icon name="check" type="mat-icon" *ngIf="renderCheckIcon"></app-pencil-icon>

      <app-pencil-icon
        *ngIf="forMenu"
        class="menu-arrow-icon"
        name="keyboard_arrow_right"
        type="mat-icon"
      ></app-pencil-icon>
    </div>

    <ng-content placeAtTheEnd select="[placeAtTheEnd]"></ng-content>
  </app-pencil-button>
</div>
